import { Card, CardContent } from "../ui/card";
import Icon from "../atoms/Icon";
import Link from "next/link";

type Props = {
  title: string;
  iconSrc: string;
  iconHoverSrc: string;
  text: string;
  href: string;
  className?: string;
};

export function CardHero({
  title,
  text,
  iconSrc,
  iconHoverSrc,
  href,
  className,
}: Props) {
  return (
    <Card
      className={[
        "relative group cursor-pointer rounded-2xl border-2 border-primaryGreen hover:border-primaryGreen hover:shadow-md transition duration-300 hover:bg-gradient-to-r hover:from-primaryGreen hover:to-accent flex items-center gap-4 shadow-sm",
        className ?? "",
      ].join(" ")}
    >
      <CardContent className="p-3  flex justify-center items-center  flex-col xl:flex-row">
        {/* Icône (default + hover) */}
        <Link href={href}>
          <div className="relative w-20 h-20 3xl:w-24 3xl:h-24 shrink-0">

            {/* icône par défaut */}

            <Icon
              src={iconSrc}
              size={100}
              className="absolute inset-0  object-contain transition-opacity duration-200 group-hover:opacity-0"
            />



            {/* icône hover */}


            {iconHoverSrc && (
              <Icon
                src={iconHoverSrc}
                size={100}
                className="absolute inset-0 object-contain opacity-0 transition-opacity duration-200 group-hover:opacity-100"
              />
            )}


          </div>
          
          </Link>
        <Link href={href}>

          <h4 className="text-primaryGreen font-bold text-[22px] 3xl:text-[24px]  group-hover:text-white text-center xl:text-start">
            {title}
          </h4>
          <p className="text-center xl:text-start mt-1 text-[16px] 3xl:text-lg leading-[1.25] font-sans group-hover:text-white">
            {text}
          </p>
        </Link>
      </CardContent>
    </Card>
  );
}
